// File outline (SPEC §6 step 8): headings with change and comment counts per section.
import { toString } from 'mdast-util-to-string';
import type { DiffItem } from './blockDiff';
import type { ThreadPlacement } from './threads';

export type OutlineEntry = { item: number; depth: number; title: string; changes: number; comments: number };

export function outline(items: DiffItem[], threads: ThreadPlacement): OutlineEntry[] {
  const out: OutlineEntry[] = [];
  items.forEach((it, i) => {
    const node = 'head' in it ? it.head.node : it.base.node;
    if (node.type === 'heading' && it.kind !== 'removed') out.push({ item: i, depth: node.depth, title: toString(node), changes: 0, comments: 0 });
    const current = out.at(-1);
    if (!current) return;
    if (it.kind !== 'same') current.changes++;
    current.comments += (threads.byItem.get(i) ?? []).reduce((n, t) => n + t.comments.length, 0);
  });
  return out;
}
